import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
// Basit bir stil objesi, daha sonra CSS dosyasına taşınabilir
const layoutStyle = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  width: '100%',
  overflow: 'hidden', // Prevent horizontal scrolling
};

const contentStyle = {
  flex: 1,
  padding: '20px',
  maxWidth: '98%',
  margin: '0 auto',
  width: '100%',
  boxSizing: 'border-box', // Include padding in width calculation
};

const Layout = ({ children }) => {
  return (
    <div style={layoutStyle}>
      <Navbar />
      <main style={contentStyle}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
